import jwt from 'jsonwebtoken';
import type { Locale } from '@libs/core';

import { ENV_VARIABLES } from '../constants';

export const isTokenValid = (token: string, locale: Locale) => {
    const { DOORDASH_SIGNING_SECRET } = ENV_VARIABLES[locale];

    if (!DOORDASH_SIGNING_SECRET) {
        throw new Error('DOORDASH_SIGNING_SECRET_US is not defined');
    }

    try {
        jwt.verify(token, Buffer.from(DOORDASH_SIGNING_SECRET, 'base64'), {
            algorithms: ['HS256'],
        });
        return true;
    } catch (error) {
        return false;
    }
};
